import {
  useEffect,
  useState
} from "react";

import api from "../api";

function PaiementForm({
  sejourId,
  montantInitial,
  montantVerrouille = false,
  onClose
}) {

  const [montant, setMontant] =
    useState("");

  const [mode, setMode] =
    useState("cash");

  const [loading, setLoading] =
    useState(false);

  const [error, setError] =
    useState("");

  // =====================
  // INIT
  // =====================

  useEffect(() => {

    if (
      montantInitial !==
        undefined &&
      montantInitial !== null
    ) {

      const val =
        Number(
          montantInitial
        );

      if (
        !isNaN(val) &&
        val > 0
      ) {

        setMontant(val);

      }
    }

  }, [montantInitial]);

  // =====================
  // SUBMIT
  // =====================

  const handleSubmit =
    async () => {

      setError("");

      if (
        !montant ||
        Number(
          montant
        ) <= 0
      ) {

        return setError(
          "Montant invalide"
        );
      }

      if (!mode) {

        return setError(
          "Mode de paiement requis"
        );
      }

      if (
        !window.confirm(
          "Confirmer paiement ?"
        )
      ) {
        return;
      }

      setLoading(true);

      try {

        await api.post(
          "/paiements",
          {
            sejour_id:
              sejourId,

            montant:
              Number(
                montant
              ),

            mode_paiement:
              mode
          }
        );

        alert(
          "Paiement effectué"
        );

        onClose();

      } catch (err) {

        console.error(err);

        setError(
          err?.response
            ?.data?.error ||
            "Erreur paiement"
        );

      } finally {

        setLoading(false);

      }
    };

  // =====================
  // RENDER
  // =====================

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-3">

      <div className="bg-white rounded-2xl shadow-2xl p-5 md:p-6 w-full max-w-md space-y-5">

        {/* HEADER */}
        <div className="text-center">

          <h3 className="text-2xl font-bold">
            Paiement
          </h3>

          <p className="text-sm text-gray-500 mt-1">
            Validation du paiement client
          </p>

        </div>

        {/* ERROR */}
        {error && (

          <div className="bg-red-100 border border-red-200 text-red-700 p-3 rounded-xl text-sm">
            {error}
          </div>

        )}

        {/* MONTANT */}
        <div>

          <label className="block text-sm text-gray-600 mb-2">
            Montant
          </label>

          <input
            type="number"
            value={montant}
            disabled={
              montantVerrouille
            }
            onChange={(e) => {

              if (
                !montantVerrouille
              ) {

                setMontant(
                  e.target.value
                );
              }

            }}
            className={`w-full border px-4 py-3 rounded-xl outline-none focus:ring-2 focus:ring-green-400 ${
              montantVerrouille
                ? "bg-gray-100 text-gray-500"
                : ""
            }`}
            placeholder="Montant"
          />

        </div>

        {/* MODE */}
        <div>

          <label className="block text-sm text-gray-600 mb-2">
            Mode de paiement
          </label>

          <select
            value={mode}
            onChange={(e) =>
              setMode(
                e.target.value
              )
            }
            className="w-full border px-4 py-3 rounded-xl outline-none focus:ring-2 focus:ring-green-400"
          >

            <option value="cash">
              💵 Cash
            </option>

            <option value="mobile">
              📱 Mobile Money
            </option>

            <option value="banque">
              🏦 Banque
            </option>

          </select>

        </div>

        {/* ACTIONS */}
        <div className="flex flex-col md:flex-row gap-3 pt-2">

          <button
            onClick={
              handleSubmit
            }
            disabled={loading}
            className="flex-1 bg-green-600 hover:bg-green-700 transition text-white py-3 rounded-xl disabled:opacity-50"
          >
            {loading
              ? "Traitement..."
              : "Valider"}
          </button>

          <button
            onClick={onClose}
            className="flex-1 bg-gray-300 hover:bg-gray-400 transition py-3 rounded-xl"
          >
            Annuler
          </button>

        </div>

      </div>

    </div>
  );
}

export default PaiementForm;